import React from 'react';
import { useParams } from 'react-router-dom';

import Page from 'App/components/Page';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import FlexCenter from 'App/components/styles/FlexCenter';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import useFetchAssessmentSettings from '../hooks/useFetchAssessmentSettings';
import AssessmentManagerSettingsForm from './AssessmentManagerSettingsForm';

const AssessmentManagerEditSettings = () => {
    const { categoryId, assessmentId } = useParams();
    const { data: settings, isLoading } = useFetchAssessmentSettings(categoryId, assessmentId);

    return (
        <Page permissionType={PERMISSION_TYPES.ASSESSMENT_MANAGER} title="Edit Assessment">
            {isLoading ? (
                <FlexCenter>
                    <TherigyLoadingSpinner />
                </FlexCenter>
            ) : (
                <AssessmentManagerSettingsForm existingSettings={settings} />
            )}
        </Page>
    );
};

export default AssessmentManagerEditSettings;
